import Styled from 'styled-components';
import { Modal } from 'antd';

const ModalStyled = Styled(Modal)`
`;

export { ModalStyled };
